import { FormikErrors, FormikTouched, getIn } from 'formik';
import { get } from 'lodash';
import { deepGetFirstNumberOrString } from '../../Shared/ObjectUtilities';

export function getErrorText(form: any, name: string, force: boolean = false): string {
    if (!force) {
        const touch = getIn(form.touched, name, false);
        if (!touch) return '';
    }

    const error = getIn(form.errors, name, '');
    const errorText = deepGetFirstNumberOrString(error).toString();

    return !!errorText ? errorText : '';
}

export function getErrorIfTouched<T>(path: string, errors: FormikErrors<T>, touchedFields?: FormikTouched<T>): string {
    const error = get(errors, path, '');
    const fieldTouched = touchedFields ? get(touchedFields, path, false) : true;
    return fieldTouched ? error : '';
}

// Expects to return 0-1 error strings for each item in the array or first level property if object
export function getErrorIfTouchedFromObject<T>(
    path: string,
    errors: FormikErrors<T>,
    touchedFields?: FormikTouched<T>
): string[] {
    const errorItem = get(errors, path, '');
    if (!errorItem) return [];

    if (typeof errorItem !== 'object') {
        // String, just return the error
        const errorIfTouched = getErrorIfTouched(path, errors, touchedFields);
        if (!!errorIfTouched) return [errorIfTouched];
    } else if (!Array.isArray(errorItem)) {
        // Object, return 1 error for each property with a error.
        const newErrors: string[] = [];
        for (const errorItemKey in errorItem) {
            if (errorItem.hasOwnProperty(errorItemKey)) {
                // Create the property sub path
                const subItemPath = `${path}.${errorItemKey}`;
                const subItemError = getErrorIfTouchedFromObject(subItemPath, errors, touchedFields);
                // If it's a sub-array || sub-object, only return the first error. Not all of them.
                // If the user cared about all of them, they will ask at that lower level
                if (subItemError.length > 0) newErrors.push(subItemError[0]);
            }
        }
        if (newErrors.length > 0) return newErrors;
    } else {
        // Array, loop through each item and return a error if it has one.
        return errorItem
            .map((it: object | string | number | (object | string | number)[], index: number): string => {
                const errorItemPath = `${path}[${index}]`;

                const subErrors = getErrorIfTouchedFromObject(errorItemPath, errors, touchedFields);

                return subErrors.length > 0 ? subErrors[0] : '';
            })
            .filter(it => !!it);
    }

    return [];
}
